interface ZarityMarkProps {
  /** "primary" = forest mark for light backgrounds; "reversed" = cream+citron for dark backgrounds */
  variant?: "primary" | "reversed";
  size?: number;
  className?: string;
}

/**
 * Zarity seed-sprout mark. Two leaves cradling a forest circle of care, with
 * the citron seed at the centre. Use "reversed" on dark (Forest) backgrounds.
 */
export function ZarityMark({
  variant = "primary",
  size = 32,
  className,
}: ZarityMarkProps) {
  const reversed = variant === "reversed";
  const leaves = reversed
    ? "oklch(var(--sidebar-foreground))"
    : "oklch(var(--primary))";
  const circle = reversed
    ? "oklch(var(--sidebar-primary))"
    : "oklch(var(--primary))";
  const seed = reversed
    ? "oklch(var(--sidebar-primary-foreground))"
    : "oklch(var(--accent))";

  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
    >
      <path d="M50 84 C31 82 18 66 21 50 C37 58 48 70 50 84 Z" fill={leaves} />
      <path d="M50 84 C69 82 82 66 79 50 C63 58 52 70 50 84 Z" fill={leaves} />
      <circle cx="50" cy="32" r="18" fill={circle} />
      <circle cx="50" cy="32" r="7.2" fill={seed} />
    </svg>
  );
}
